import React from 'react';
import LatestSidebar from './LatestSidebar';
import FeaturedStory from './FeaturedStory';
import NewsGrid from './NewsGrid';
import TwoColumnSection from './TwoColumnSection';
import OpinionSection from './OpinionSection';
import EditorialTopicsGrid from './EditorialTopicsGrid';
// import GamesSection from './GamesSection';
import './MainContent.css';

const MainContent = () => {
  return (
    <main className="main-content">

      <div className="container">
        <div className="content-wrapper">
          {/* Main Content Area – hidden on mobile */}
          <div className="main-content-area desktop-only">
            <FeaturedStory />
            <NewsGrid />
          </div>

          {/* Latest Sidebar – always visible */}
          <LatestSidebar />
        </div>

        {/* Two Column Video Section – hidden on mobile */}
        <div className="desktop-only">
          <div className="section-divider"></div>
          <TwoColumnSection />
        </div>

        {/* Bloomberg Opinion Section – hidden on mobile */}
        <div className="desktop-only">
          <div className="section-divider"></div>
          <OpinionSection />
        </div>

        {/* Editorial Topics Grid – always visible */}
        <div className="section-divider"></div>
        <EditorialTopicsGrid />

        {/* Games Section – hidden on mobile */}
        <div className="desktop-only">
          <div className="section-divider"></div>
          {/* <GamesSection /> */}
        </div>
      </div>
    </main>
  );
};

export default MainContent;
